import { useTranslation } from "react-i18next"
import { Button, MyTableComponent } from "components"
import { Box } from "theme-ui"

export const DevicesSignalGroup = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   info1: "01",
   info2: "K1",
   info3: "Entfernen",
  },
  {
   info1: "01",
   info2: "K1",
   info3: "Entfernen",
  },
 ]

 const columns = [
  { Header: "Nr", accessor: "info1" },

  {
   Header: "Name",
   Cell: ({ row }: any) => (
    <div className="bg-gray py-2 rounded text-start text-black pl-2">{row.original.info2}</div>
   ),
  },
  {
   Header: "Action",
   Cell: ({ row }: any) => (
    <div className="bg-light-pink text-dark-pink border-light-pink border py-2 rounded ">
     {row.original.info3}
    </div>
   ),
  },
 ]

 return (
  <div className="w-[96%] mx-auto pt-7">
   <h1 className="font-semibold Jakarta-font text-lg pb-2">{t("defineRleaseAndBlockingTimes")}</h1>
   <Box bg="light_gray" color="text-black">
    <ul className="flex w-full flex-wrap overflow-x-auto whitespace-nowrap Jakarta-font py-2">
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">STm.5</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">STm.6</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">Testanglag 01</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">Testanglag 01 Copy</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">UCM-Test</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/"> XXX XXX</a>
     </li>
    </ul>
   </Box>

   <Box bg="highlight" className="px-2">
    <div className="flex flex-wrap justify-between w-full py-2">
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("plantData")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("signalPrograms")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"}>{t("signalGroups")}</Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("detectors")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("publicTransportReportingPoints")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("apValues")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("OCITList")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("OCIT-ISettings")}
      </Button>
     </div>
     <div className="py-2">
      <Button size={"sm"} color={"white"}>
       {t("plantGroups")}
      </Button>
     </div>
    </div>

    <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
    <div className="flex justify-center py-8 w-full lg:flex-row flex-col">
     <div className="py-2">
      <Button color={"green"} size={"doublexl"}>
       {t("save")}
      </Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button color={"lightBrown"} size={"doublexl"}>
       {t("new")}
      </Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button color={"pink"} size={"doublexl"}>
       {t("delete")}
      </Button>
     </div>
     <div className="lg:ml-2 py-2">
      <Button color={"blue"} size={"doublexl"}>
       XML-Upload
      </Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
